/**
 * @Description //TODO 全局变量 参数
 * @author
 * @date
 * @Ver
 * @extends Vue
 */

/**
 * @Des 加载参数
 * @Auth
 * @Date
 */

// 变量
let power1s = [];// 功率1
let power2s = [];// 功率2
let timeSlots = [];// 时隙
let panIds = [];// 过滤组


(function loadParams() {
    // 功率1
    power1s = [];
    let v = 18;
    let i = 0;
    while (v >= 0){
        power1s.push(v);
        i++;
        v = v-3;
    }
    // 功率2
    power2s = [];
    v = 0;
    i = 0;
    while (v <= 15.5){
        power2s.push(v);
        i++;
        v = v + 0.5;
    }
    // 时隙
    timeSlots = [];
    for (let i=0;i<10;i++){
        timeSlots.push(i)
    }
    // 过滤组
    panIds = [];
    for(let i=1;i<6;i++){
        panIds.push(i)
    }
})();

// 基站状态
const bsStatus = {1: '在线',2: '离线'};
// 基站类型
const bsModes = {17: '白盒基站',18: '球形基站',19: '室外基站',24: '无人机基站'};

const weeks = {1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六', 7: '星期日'}

// 绑定类型
const bindTypes = {0: '未绑定', 1: '绑定人', 2: '绑定车'};
// 坐标系类型
const coordinateTypes = {1: 'GPS坐标系', 2: '高德坐标系'};

export default {
    power1s,// 功率1
    power2s,// 功率2
    timeSlots,// 时隙
    panIds,// 过滤组
    bsStatus,// 基站状态
    bsModes,// 基站类型
    weeks, // 星期
    bindTypes,// 绑定类型
    coordinateTypes,// 坐标系类型
}



// WEBPACK FOOTER //
// ./src/global/global-param.js